import React from "react";
import { connect } from "react-redux";

import { IAppState } from "../../state/Store";
import { initialiseClientSystems } from "../../state/core/ClientSystem";
import ClientSystem from "../../types/core/ClientSystem";

import "./AppsMenu.scss";

interface AppsMenuProps {
    open: boolean;
    items: Array<ClientSystem>;
    initialiseClientSystems: Function;
}

interface AppsMenuState {}

class AppsMenu extends React.Component<AppsMenuProps, AppsMenuState> {
    state = {};

    componentDidMount(): void {
        this.props.initialiseClientSystems();
    }

    render() {
        return (
            this.props.open && (
                <div className="apps-menu-slide">
                    <div className="apps-menu">
                        <div className="app-links app-items">
                            <span className="title">Applications</span>

                            <div className="items">
                                {this.props.items.map((item, index) =>
                                    !!item.applicationPath ? (
                                        <a
                                            key={index}
                                            className="item"
                                            href={item.applicationPath}
                                            data-place="left"
                                            data-tip={item.description}>
                                            <div className="icon-cont">
                                                <img
                                                    src={item.logoFile}
                                                    alt="App Icon"></img>
                                            </div>

                                            <span>{item.name}</span>
                                        </a>
                                    ) : null,
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            )
        );
    }
}

const mapStateToProps = (state: IAppState) => {
    const { clientSystem } = state.db;
    return {
        items: clientSystem.clientSystems,
    };
};

const mapDispatchToProps = dispatch => {
    return {
        initialiseClientSystems: () => initialiseClientSystems(),
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(AppsMenu);
